import { talentAxios } from '@/utils/request';

let Api = {
  translate: '/outer-api/translate/toChinese',
};

// 翻译为中文
export const translateToChineseApi = (params) => {
  return talentAxios.get(Api.translate, { params });
};
